<template>
  <a-layout-footer class="footer">&copy; 上海法法信息技术有限公司</a-layout-footer>
</template>

<script>
  export default {
    name: 'dol-footer',
    data () {
      return {}
    },
    methods: {

    },
    created(){
    }
  }
</script>
